<template>
  <div class="fullWidth fCol jStart aStart inputHolder">
    <div class="fCol jCenter aCenter fullWidth"
      v-if="loading || noContent">
      <p-bar
        :loading="loading"
        :notYet="notYet"
        :noContent="noContent"
        :notFound="notFound"
        :error="error" />
    </div>
    <div class="fullWidth fCol jStart aStart" v-if="loaded">
      <span class="fRow jStart aCenter">
        <i class="material-icons-round"
          v-bind:class="{inpErr: selectedConsultants.length < 1}">account_circle</i>
        انتخاب مشاور
      </span>
      <div class="fullWidth fRow jBetween aStart consultantHolder wrap">
        <div class="fullWidth fRow jStart aStart header wrap">
          <span class="t">مشاورین را انتخاب کنید:</span>
          <div class="filters fRow jStart aCenter">
            <div class="cheap transition-medium"
              @click="consultantFilter = 0"
              v-bind:class="{
                selected: consultantFilter === 0,
              }">همه‌ی مشاورین</div>
            <div class="cheap transition-medium"
              @click="consultantFilter = 2"
              v-bind:class="{
                selected: consultantFilter === 2,
              }">مشاورین جذب</div>
            <div class="cheap transition-medium"
              @click="consultantFilter = 1"
              v-bind:class="{
                selected: consultantFilter === 1,
              }">مشاورین آموزشی</div>
          </div>
          <input type="text" class="search fullWidth"
            placeholder="نام مشاور را جستجو کنید"
            v-model="consultantSearch">
        </div>
        <div class="items w60 fRow jBetween aCenter wrap">
          <h2 class="fullWidth"
            v-if="filteredConsultants.length !== 0">مشاورها را انتخاب کنید
            ({{filteredConsultants.length}} مشاور)
          </h2>
          <div class="item fRow jStart aCenter w50 transition-fast"
            @click="selectConsultant(item.id)"
            v-bind:class="{
              selectedItem: selectedConsultants.includes(item.id),
              gone: consultantFilter !== item.type && consultantFilter !== 0,
            }"
            v-for="(item, index) in filteredConsultants" v-bind:key="index">
            <i class="check material-icons-round">
              {{!selectedConsultants.includes(item.id)
                ? 'radio_button_unchecked' : 'task_alt'}}
            </i>
            <span class="name growFull">{{item.title}}</span>
            <span class="type">{{item.type === 2 ? 'مشاور جذب' : 'مشاور آموزشی'}}</span>
          </div>
          <div class="noResult fCol fullWidth jCenter aCenter"
            v-if="filteredConsultants.length === 0">
            <i class="material-icons-round">error</i>
            <span>نتیجه‌ای یافت نشد</span>
            <div class="mini" @click="consultantSearch = ''">حذف فیلتر</div>
          </div>
        </div>
        <div class="selectedItems w40 fCol jStart aCenter">
          <h2 class="fullWidth">مشاورین انتخاب شده:</h2>
          <div class="item fRow jStart aCenter fullWidth transition-fast"
            v-for="(item, index) in selectedItems" v-bind:key="index">
            <span class="index">{{index + 1}}</span>
            <span class="name growFull">{{item.title}}</span>
            <span class="type">{{item.type === 2 ? 'مشاور جذب' : 'مشاور آموزشی'}}</span>
            <i class="ac material-icons-round"
              @click="deleteConsultant(item.id)">delete</i>
          </div>
          <div class="noResult fCol fullWidth jCenter aCenter"
            v-if="selectedItems.length === 0">
            <i class="material-icons-round">error</i>
            <span>هیچ مشاوری انتخاب نشده</span>
            <!-- <div class="mini"></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import pBar from '@/components/pBar.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';

export default {
  mixins: [errorHandler, makeToast],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: false,
      loaded: true,
      modeMsg: '',
      // modes ↑
      consultantTypes: [
        {
          id: 1,
          title: 'مشاور آموزشی',
        },
        {
          id: 2,
          title: 'مشاور جذب',
        },
      ],
      consultantType: '',
      consultantTypeErr: true,
      consultantFilter: 0,
      consultants: [],
      consultantSearch: '',
      selectedConsultants: [],
      selectedConsultantsErr: true,
      selectedItems: [],
    };
  },
  components: {
    pBar,
  },
  watch: {
    selectedConsultants() {
      this.selectedItems = [];
      for (let i = 0; i < this.consultants.length; i += 1) {
        if (this.selectedConsultants.includes(this.consultants[i].id)) {
          this.selectedItems.push(this.consultants[i]);
        }
      }
      if (this.selectedConsultants.length === 0) {
        this.selectedConsultantsErr = true;
      } else {
        this.selectedConsultantsErr = false;
      }
    },
  },
  methods: {
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    getConventions() {
      this.setMode('loading');
      this.conventions = [{
        title: 'لطفا صبر کنید',
        id: '',
      }];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Consultants`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.conventions = [];
          const arr = response.data.data;
          if (arr.length === 0) {
            this.setMode('noContent');
            // ریست کردن لیست ها
            this.conventions = [{
              title: 'مشاور ثبت نشده',
              id: '',
            }];
          } else {
            for (let i = 0; i < arr.length; i += 1) {
              this.conventions.push({
                id: arr[i].id,
                title: arr[i].fullName,
              });
            }
            this.conventionsData = response.data.data;
            this.consultants = [];
            for (let i = 0; i < this.conventionsData.length; i += 1) {
              const a = {
                id: this.conventionsData[i].id,
                title: this.conventionsData[i].fullName,
                type: this.conventionsData[i].consultantType,
              };
              this.consultants.push(a);
            }
            this.setMode('loaded');
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.setMode('error', this.errorHandler(error));
        // console.log(error);
      }).catch(() => {
        this.setMode('error', 'در صورت درستی اتصال اینترنت، با تیم فنی تماس بگیرید');
      });
    },
    selectConsultant(id) {
      const isThere = this.selectedConsultants.indexOf(id);
      if (isThere === -1) {
        this.selectedConsultants.push(id);
      } else {
        this.selectedConsultants.splice(isThere, 1);
      }
      // console.log(this.selectedConsultants);
    },
    deleteConsultant(i) {
      // console.log(i);
      const index = this.selectedConsultants.indexOf(i);
      this.selectedConsultants.splice(index, 1);
    },
  },
  computed: {
    filteredConsultants() {
      // eslint-disable-next-line
      return this.consultants.filter((item) => item.title.toLowerCase().includes(this.consultantSearch.toLowerCase()));
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getConventions();
    });
  },
};
</script>

<style lang="scss" scoped>

  .consultantHolder {
    input.search {
      outline: 0;
      margin-top: 16px;
      padding: 8px 16px;
      border: solid 1px rgba($color: #000000, $alpha: 0.35);
    }
    padding: 16px;
    .header {
      padding-bottom: 16px;
      margin-bottom: 16px;
      border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.25);
      span.t {
        font-size: 14px;
        text-align: right;
        margin-left: 16px;
        color: black;
      }
      .filters {
        span.o {
          font-size: 12px;
          font-weight: bold;
          margin-left: 16px;
        }
        .cheap {
          padding: 4px 8px;
          border-radius: 24px;
          background-color: rgba($color: #000000, $alpha: 0.05);
          font-size: 12px;
          margin-left: 8px;
          cursor: pointer;
        }
        .cheap.selected {
          background-color: rgba($color: #2d9146, $alpha: 1);
          box-shadow: 0 12px 12px -12px rgba($color: #000000, $alpha: 1);
          color: white;
        }
      }
    }
    .items {
      max-height: 450px;
      overflow: hidden auto;
      padding: 16px;
      padding-bottom: 8px;
      border-radius: 16px;
      border: solid 2px rgba($color: #000000, $alpha: 0.05);
      .item {
        border-radius: 16px;
        padding: 8px;
        margin-bottom: 8px;
        border: solid 2px rgba($color: #000000, $alpha: 0.05);
        cursor: pointer;
        i.check {
          font-size: 16px;
          margin-left: 4px;
        }
        span.name {
          font-size: 12px;
          font-weight: bold;
          color: #303030;
          text-align: right;
        }
        span.type {
          font-size: 12px;
          font-weight: 200;
          color: #646464;
        }
      }
      .item.gone {
        display: none;
      }
      .item:nth-child(2n+1) {
        background-color: rgba($color: #000000, $alpha: 0.0);
      }
      .item:hover {
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      .item.selectedItem {
        border: solid 2px rgba($color: #19b146, $alpha: 0.85) !important;
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
    }
    h2 {
      padding: 0;
      margin: 0 0 16px 0;
      font-size: 14px;
      padding-bottom: 16px;
      border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.05);
    }
    .selectedItems {
      padding: 16px;
      border-radius: 16px;
      border: solid 2px rgba($color: #000000, $alpha: 0.05);
      .item {
        border-radius: 24px 8px 8px 24px;
        padding: 4px 8px 4px 4px;
        cursor: pointer;
        span.index {
          margin-left: 4px;
          font-size: 10px;
          text-align: right;
          min-width: 16px;
          width: 16px;
          line-height: 1;
        }
        span.name {
          font-size: 12px;
          font-weight: bold;
          color: #303030;
          text-align: right;
        }
        span.type {
          font-size: 10px;
          font-weight: bold;
          color: #646464;
          white-space: nowrap;
        }
        i.ac {
          font-size: 16px;
          padding: 8px;
          margin-right: 8px;
          border-radius: 50%;
          background-color: rgba($color: #000000, $alpha: 0.05);
        }
        i.ac:hover {
          background-color: rgba($color: #000000, $alpha: 0.15);
        }
      }
      .item:nth-child(2n+1) {
        background-color: rgba($color: #000000, $alpha: 0.02);
      }
    }
    .noResult {
      height: 192px;
      i {
        font-size: 24px;
        color: rgba($color: #000000, $alpha: 0.25);
        margin-bottom: 8px;
      }
      span {
        font-size: 12px;
        width: 80%;
        text-align: center;
      }
      .mini {
        font-size: 12px;
        cursor: pointer;
        margin-top: 16px;
        padding: 4px 8px;
        border-radius: 16px;
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      .mini:hover {
        background-color: rgba($color: #000000, $alpha: 0.08);
      }
    }
  }
</style>
